import i18next from 'i18next';
import * as Yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const registrationPageTwoValidationSchema = Yup.object().shape({
  FirstName: Yup.string()
    .trim()
    .matches(
      /^(?!.*\p{Sc})(?!.*\p{Cc})[^\p{Cc}!@#$%*()+=?:;"`[\]{}<>~^_/\\|]*$/u,
      i18next.t(`validationSchema.general.invalidCharacters`),
    )
    .nullable()
    .required(i18next.t('validationSchema.general.legalFirstNameRequired'))
    .max(50, i18next.t(`validationSchema.general.legalFirstNameMaxLength`)),

  LastName: Yup.string()
    .trim()
    .matches(
      /^(?!.*\p{Sc})(?!.*\p{Cc})[^\p{Cc}!@#$%*()+=?:;"`[\]{}<>~^_/\\|]*$/u,
      i18next.t(`validationSchema.general.invalidCharacters`),
    )
    .nullable()
    .required(i18next.t('validationSchema.general.legalLastNameRequired'))
    .max(50, i18next.t(`validationSchema.general.legalLastNameMaxLength`)),

  PhoneNumber: Yup.string()
    .required(i18next.t('validationSchema.general.phoneNumberRequired'))
    .test(
      'is-valid-phone',
      i18next.t('quickRegistration.errors.phone'),
      (value) => !!value && isValidPhoneNumber(value),
    )
    .max(50, i18next.t('validationSchema.general.phoneNumberMaxLength')),
});
